import {
  LOCALE_ID, Pipe, PipeTransform, inject,
} from '@angular/core'
import {
  Duration, DurationUnit,
} from 'luxon'

@Pipe({
  name: 'humanDuration',
  standalone: true,
})
export class HumanDurationPipe implements PipeTransform {
  private localeId = inject(LOCALE_ID)

  public transform(
    duration: Duration,
    unitDisplay: 'long' | 'short' | 'narrow' = 'narrow',
    listStyle: 'long' | 'short' | 'narrow' = 'narrow',
    units: DurationUnit[] = ['hours', 'minutes', 'seconds'],
  ): string {
    return duration
      .reconfigure({ locale: this.localeId })
      .shiftTo(...units)
      .mapUnits(x => Math.round(x))
      .toHuman({
        listStyle: listStyle,
        unitDisplay: unitDisplay,
      })
    // TODO: remove leading and trailing zero units
  }
}
